import { render, staticRenderFns } from "./MagazzinoArticoliGiacenzaWrapperComponent.vue?vue&type=template&id=d5ab02c4&scoped=true"
import script from "./MagazzinoArticoliGiacenzaWrapperComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliGiacenzaWrapperComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ab02c4",
  null
  
)

export default component.exports